import React, { Dispatch } from 'react'

interface PropsResetFilter {
	handlerHiddenFilter: Dispatch<any>
  setCheckedValue:Dispatch<any>
  setMealValue:Dispatch<any>
  timeData:any
  setTimeData:Dispatch<any>
}

export const useResetFilter = ({
	handlerHiddenFilter,
	setCheckedValue,
	setMealValue,
	timeData,
	setTimeData
}: PropsResetFilter) => {
	const handlerReset = () => {
		handlerHiddenFilter(false)
		setCheckedValue([true, true, true, true, true])
		setMealValue(['RO', 'BB', 'HB', 'FB', 'AI', 'UAI'])
		const nights_min = 5
		const nights_max = 8
		const newDate = {
			...timeData,
			nights_min,
			nights_max,
			price_range_min: 100,
			price_range_max: 10000,
			meal_types: ['RO', 'BB', 'HB', 'FB', 'AI', 'UAI'],
			rating: [true, true, true, true, true]
		}
		// searchToursMain.mutate(newDate)
		// setTimeData(newDate)
		localStorage.setItem('userInfo', JSON.stringify(newDate))
	}
  return {handlerReset}
}
